import http from "@/services/http";

/**
 * Consulta ao catálogo CID-10 — vocabulário, não dado de paciente.
 *
 * Os CIDs *do paciente* ficam em `patient_conditions` e são acessados pelo
 * `conditionService`. Este arquivo só pesquisa o código no catálogo externo;
 * quem grava o resultado é o `conditionService.createConditions`.
 *
 * (Existia aqui um `getCidsByPatient`/`createPatientCids`/`deletePatientCid`
 * apontando para a tabela `patient_cids`, estrutura duplicada que nunca chegou
 * a receber dado e foi removida do projeto.)
 */

/**
 * Busca CIDs no catálogo pelo texto informado.
 * Normaliza a resposta `{ categorias: [...], subcategorias: [...] }` numa única
 * lista pronta para exibição, marcando o tipo de cada item.
 *
 * @param {string} texto
 * @returns {Promise<Array<{code:string, description:string, description_abbrev:string,
 *   type:string, parent_code:string|null, snomed_code:string|null, tuss_code:string|null,
 *   label:string}>>}
 */
export async function searchCids(texto) {
  const { data } = await http.post("/api/cid-catalog/search", { texto });

  const map = (item, type) => ({
    code: item.codigo,
    description: item.descricao,
    description_abbrev: item.descricao_abrev || null,
    type,
    parent_code: item.codigo_pai || null,
    snomed_code: item.snomed_code || null,
    tuss_code: item.tuss_code || null,
    label: `${item.codigo} — ${item.descricao}`,
  });

  const categorias = (data?.categorias || []).map((c) => map(c, "categoria"));
  const subcategorias = (data?.subcategorias || []).map((s) =>
    map(s, "subcategoria"),
  );

  // Categorias primeiro (mais genéricas), depois subcategorias.
  return [...categorias, ...subcategorias];
}
